module.exports = __webpack_public_path__ + "img/aston-search.23e1b71d.webp";